import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../ui/sheet';

export const Panel = ({ open, onClose, title, description, theme, id, children }) => <Sheet open={open} onOpenChange={value => { if (!value) onClose(); }}>
  <SheetContent className="pm-dialog pm-drawer" data-theme={theme} data-testid={id}>
    <SheetHeader className="pm-drawer-header"><SheetTitle data-testid={`${id}-title`}>{title}</SheetTitle><SheetDescription className="pm-muted" data-testid={`${id}-description`}>{description || ''}</SheetDescription></SheetHeader>
    <div className="pm-drawer-content">{children}</div>
  </SheetContent>
</Sheet>;